module.exports = __webpack_public_path__ + "static/media/mounting-hardware.1eadbb30.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/features/mounting-hardware.png
// module id = 1226
// module chunks = 0